export default __webpack_public_path__ + "static/media/cytocaare-banner-03.556dba98.jpg";